import './style.css.js';
import { Button } from '@magnetic/button';
import { Flex } from '@magnetic/flex';
import { useClassNames, useBoolean } from '@magnetic/hooks';
import { Status, CopySimple } from '@magnetic/icons';
import { Popover } from '@magnetic/popover';
import { Tooltip } from '@magnetic/tooltip';
import React, { forwardRef, useCallback } from 'react';

const IconOnly = forwardRef(
  ({
    className,
    copyText = "Copy",
    size = "md",
    value,
    ...rest
  }, ref) => {
    const classNames = useClassNames(className);
    const {
      setFalse: setShowTooltipFalse,
      setTrue: setShowTooltipTrue,
      value: showTooltip
    } = useBoolean(true);
    const onClick = useCallback(() => {
      navigator.clipboard.writeText(value);
      setShowTooltipFalse();
    }, [value, setShowTooltipFalse]);
    const setOpen = useCallback(() => {
      setShowTooltipTrue();
    }, [setShowTooltipTrue]);
    return /* @__PURE__ */ React.createElement(
      Popover,
      {
        open: !showTooltip,
        setOpen,
        title: /* @__PURE__ */ React.createElement(Flex, { align: "center", gap: 4 }, /* @__PURE__ */ React.createElement(Status, { status: "good" }), "Copied to clipboard")
      },
      /* @__PURE__ */ React.createElement(Tooltip, { disabled: !showTooltip, title: "Copy to clipboard" }, /* @__PURE__ */ React.createElement(
        Button,
        {
          "aria-label": `${copyText}: ${value}`,
          className: classNames,
          icon: /* @__PURE__ */ React.createElement(CopySimple, null),
          id: "button",
          kind: "tertiary",
          onClick,
          ref,
          size,
          ...rest
        }
      ))
    );
  }
);

export { IconOnly };
//# sourceMappingURL=icon-only.js.map
